import { useEffect } from 'react';

export const useStorageUsage = getStorageUsageRequest => {
    useEffect(() => {
        const timer = setInterval(() => getStorageUsageRequest(), 7.2e6);

        return () => clearInterval(timer);
    }, []);
};
